import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

const getListRekapPesertaButawarna = async (tahun: string) => {
  const response = await api.get("/setting/verifikator-butawarna/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data;
};

export default function SettingVerifikatorButawarnaPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRekapPesertaButawarna", selectedTahun?.label],
    queryFn: () => getListRekapPesertaButawarna(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
